import { createAction, props } from '@ngrx/store';
import { Supplements } from '@core/models/Supplement/Supplements.model';
import { Rate } from '@core/models/Rate/Rate.model';

export enum DisneyTicketsActions {
  SET_TICKETS = '[DisneyTickets] SET_TICKETS',
  SET_SELECTED_TICKET = '[DisneyTickets] SET_SELECTED_TICKET',
  UNSET_SELECTED_TICKET = '[DisneyTickets] UNSET_SELECTED_TICKET',
  SET_SELECTED_RATE = '[DisneyTickets] SET_SELECTED_RATE',
  CHECK_SELECTED_RATE = '[DisneyTickets] CHECK_SELECTED_RATE',
  UNSET_SELECTED_RATE = '[DisneyTickets] UNSET_SELECTED_RATE',
  RESET_DEFAULT_RATE = '[DisneyTickets] RESET_DEFAULT_RATE',
  SET_DEFAULT_RATE = '[DisneyTickets] SET_DEFAULT_RATE',
  RESET_SELECTED_RATE = '[DisneyTickets] RESET_SELECTED_RATE',
  SET_START_DATE = '[DisneyTickets] SET_START_DATE',
  RESET_DISNEY_TICKETS = '[DisneyTickets] RESET_DISNEY_TICKETS',
  CHECK_RATE_FAILED = '[DisneyTickets] CHECK_RATE_FAIL',
  CHECK_RATE_SUCCESSFUL = '[DisneyTickets] CHECK_RATE_SUCCESSFUL',
}

export const disneyTickets = createAction(
  DisneyTicketsActions.SET_TICKETS,
  props<{ disneyTicketCluster: any }>(),
);
export const setSelectedTicket = createAction(
  DisneyTicketsActions.SET_SELECTED_TICKET,
  props<{ ticket: Supplements }>(),
);
export const unsetSelectedTicket = createAction(
  DisneyTicketsActions.UNSET_SELECTED_TICKET,
);

export const setSelectedRate = createAction(
  DisneyTicketsActions.SET_SELECTED_RATE,
  props<{ rate: Rate }>(),
);

export const checkSelectedRate = createAction(
  DisneyTicketsActions.CHECK_SELECTED_RATE,
  props<{ rate: Rate }>(),
);

export const unsetSelectedRate = createAction(DisneyTicketsActions.UNSET_SELECTED_RATE);

export const resetDefaultRate = createAction(DisneyTicketsActions.RESET_DEFAULT_RATE);

export const setDefaultRate = createAction(
  DisneyTicketsActions.SET_DEFAULT_RATE,
  props<{ rate: Rate }>(),
);

export const resetSelectedRate = createAction(DisneyTicketsActions.RESET_SELECTED_RATE);

export const setStartDate = createAction(
  DisneyTicketsActions.SET_START_DATE,
  props<{ selectedDate: Date }>(),
);

export const resetDisneyTickets = createAction(DisneyTicketsActions.RESET_DISNEY_TICKETS);

export const checkRateFailed = createAction(DisneyTicketsActions.CHECK_RATE_FAILED);

export const checkRateSuccessful = createAction(
  DisneyTicketsActions.CHECK_RATE_SUCCESSFUL,
);
